import { styled } from "@mui/material/styles";
import { ButtonBase, ButtonBaseProps } from "@mui/material";
import { StyledComponent } from "@emotion/styled";
import { Colors } from "../../../constants";

type CoreButtonBaseVariant = 'primary' | 'secondary' | 'danger' | 'success';

export interface CoreButtonBaseProps extends ButtonBaseProps {
	variant?: CoreButtonBaseVariant;
}

const getTextColor = (variant: CoreButtonBaseVariant): string => {
	switch (variant) {
		case "primary":
			return Colors.black;
		default: return Colors.white;
	}
};

const getBackgroundColor = (variant: CoreButtonBaseVariant): string => {
	switch (variant) {
		case "secondary":
			return Colors['343434'];
		case "danger":
			return Colors.tomato_a20;
		case "success":
			return Colors['10C79B_a10'];
		default: return Colors.white;
	}
};

const getFocusTextColor = (variant: CoreButtonBaseVariant): string => {
	switch (variant) {
		case "danger":
			return Colors['FF6767'];
		case "success":
			return Colors['10C79B'];
		case "secondary":
			return Colors.white;
		default: return Colors.black;
	}
};

const getFocusBackgroundColor = (variant: CoreButtonBaseVariant): string => {
	switch (variant) {
		case "danger":
			return Colors['FF6767_a10'];
		case "success":
			return Colors['10C79B_a10'];
		case "secondary":
			return Colors['2A2A2A'];
		default: return Colors.white;
	}
};

export const CoreButtonBase: StyledComponent<CoreButtonBaseProps> = styled(ButtonBase)<CoreButtonBaseProps>(({ theme, variant = 'primary' }) => {
	const { typography, transitions } = theme;

	const textColor = getTextColor(variant);
	const focusTextColor = getFocusTextColor(variant);
	const backgroundColor = getBackgroundColor(variant);
	const focusBackgroundColor = getFocusBackgroundColor(variant);

	return {
		...typography.button,
		textTransform: 'none',
		lineHeight: '120%',
		fontSize: '13px',
		color: textColor,
		fontWeight: 700,
		border: `1px solid ${Colors.white_a10}`,
		borderRadius: '100px',
		padding: '10px 12px',
		fontFamily: 'Montserrat, sans-serif',
		backgroundColor,

		transition: transitions.create(['background-color', 'color', 'border-color'], {
			duration: transitions.duration.short
		}),
		'&:hover, &.Mui-focusVisible, &.core-button-loading': {
			color: focusTextColor,
			backgroundColor: focusBackgroundColor,
		},
		'&:active': {
			color: focusTextColor,
			backgroundColor: focusBackgroundColor
		},
		'&:disabled:not(.core-button-loading)': {
			opacity: 0.4,
		}
	};
});
